import { createContext, ReactNode, useContext, useMemo } from 'react';
import { SessionManager, getSessionManager } from './SessionManager';

const SessionManagerContext = createContext<SessionManager | null>(null);

export const SessionManagerProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const sessionManager = useMemo(
    () => (typeof window === 'undefined' ? null : getSessionManager()),
    []
  );

  return (
    <SessionManagerContext.Provider value={sessionManager}>
      {children}
    </SessionManagerContext.Provider>
  );
};

export const useSessionManager = () => {
  const context = useContext(SessionManagerContext);
  if (context) {
    return context;
  }

  if (typeof window !== 'undefined') {
    return getSessionManager();
  }

  return null;
};
